let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jljps")).then(() => parcelRequire('5SBKc'));